<template>
  <v-card warp>
    <v-card-title primary-title style="display: flex; align-items: center; justify-content: space-between">
      <h2>Play by Play</h2>
      <v-btn color="grey lighten-3" fab small @click="reverseOrder = !reverseOrder">
        <v-icon>format_line_spacing</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-title style="display: flex; align-items: center; justify-content: flex-end; padding: 0 16px">
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="actionSelection"
        :items="actionValues"
        v-if="typeSelection === 'Rally'"
      ></v-select>
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="typeSelection"
        :items="typeValues"
      ></v-select>
      <v-select
        style="width: 15%; flex: inherit"
        v-model="setSelection"
        :items="setValues"
      ></v-select>
    </v-card-title>

    <v-flex style="display: flex; border-bottom: 1px solid #eee" justify-start>
      <strong style="width: 10%">Time</strong>
      <strong style="width: 10%">Type</strong>
    </v-flex>

    <template v-for="(set, index) in filterEvents(orderedEvents)">
        <v-flex
          style="display: flex; justify-content: center; border-bottom: 1px solid #eee"
          justify-start
          :key="index"
          v-if="reverseOrder && filterEvents(orderedEvents).length > 1"
        >
          <h3>Set {{ filterEvents(orderedEvents).length - index }}</h3>
        </v-flex>

        <template v-if="!reverseOrder && set.lineUps">
          <f-lineup
            :lineup="set.lineUps[0]"
            :teams="teams"
            :players="players"
            :key="index + 1000"
          ></f-lineup>

          <f-lineup
            :lineup="set.lineUps[1]"
            :teams="teams"
            :players="players"
            :key="index + 2000"
          ></f-lineup>
      </template>

      <div v-for="(event, $index) in set.events" :key="'' + index + $index" style="font-size: 13px">
        <f-substitution
          v-if="event.code === 'Substitution'"
          :event="event"
          :players="players"
          :key="event.identifier"
          :teamA="teamA"
          :teamB="teamB"
        ></f-substitution>

        <f-timeout
          v-if="event.code === 'Timeout'"
          :event="event"
          :teams="teams"
          :key="event.identifier"
        ></f-timeout>

        <f-rally
          v-if="event.code === 'Rally'"
          :event="event"
          :teams="teams"
          :players="players"
          :key="event.identifier"
          :teamA="teamA"
          :teamB="teamB"
          :filter="actionSelection"
        ></f-rally>

        <f-technical-timeout
          v-if="event.code === 'TechnicalTimeout'"
          :event="event"
          :key="event.identifier"
        ></f-technical-timeout>

        <f-super-point
          v-if="event.code === 'SuperPoint'"
          :event="event"
          :teams="teams"
          :key="event.identifier"
        ></f-super-point>

      </div>

      <template v-if="reverseOrder && set.lineUps">
          <f-lineup
            :lineup="set.lineUps[0]"
            :teams="teams"
            :players="players"
            :key="index + 1000"
          ></f-lineup>

          <f-lineup
            :lineup="set.lineUps[1]"
            :teams="teams"
            :players="players"
            :key="index + 2000"
          ></f-lineup>
      </template>

      <v-flex style="display: flex; justify-content: center; border-bottom: 1px solid #eee" justify-start :key="index" v-if="!reverseOrder && filterEvents(orderedEvents).length > 1">
        <h3>Set {{ index + 1 }}</h3>
      </v-flex>
    </template>
  </v-card>
</template>

<script>
import Rally from './Rally'
import LineUp from './LineUp'
import Timeout from './Timeout'
import Substitution from './Substitution'
import TechnicalTimeout from './TechnicalTimeout'
import SuperPoint from './SuperPoint.vue'

export default {
  props: ['eventsBySet', 'players', 'teams', 'teamA', 'teamB'],

  data: () => ({
    reverseOrder: true,
    setSelection: -1,
    typeSelection: -1,
    actionSelection: -1,
    setValues: [],
    typeValues: [
      { text: 'All Types', value: -1 },
      { text: 'Substitution', value: 'Substitution' },
      { text: 'Rally', value: 'Rally' },
      { text: 'Timeout', value: 'Timeout' },
      { text: 'Technical Timeout', value: 'TechnicalTimeout' },
    ],
    actionValues: [
      { text: 'All Actions', value: -1 },
      { text: 'Serve', value: 4 },
      { text: 'Spike', value: 6 },
      { text: 'Block', value: 1 },
      { text: 'Set', value: 5 },
      { text: 'Dig', value: 2 },
      { text: 'Reception', value: 3 },
    ],
  }),

  created () {
    this.refreshSetSelector()
  },

  components: {
    'f-technical-timeout': TechnicalTimeout,
    'f-substitution': Substitution,
    'f-timeout': Timeout,
    'f-rally': Rally,
    'f-lineup': LineUp,
    'f-super-point': SuperPoint,
  },

  computed: {
    orderedEvents () {
      if (this.reverseOrder) {
        const sets = []

        for (let event of this.eventsBySet) {
          sets.push({
            events: event.events ? event.events.slice().reverse() : {},
            lineUps: event.lineUps
          })
        }

        return sets.slice().reverse()
      }

      return this.eventsBySet
    }
  },

  watch: {
    typeSelection (value) {
      if (value !== 'Rally') {
        this.actionSelection = -1
      }
    },

    eventsBySet () {
      this.refreshSetSelector()
    },
  },

  methods: {
    refreshSetSelector () {
      this.setValues = [
        { text: 'All Sets', value: -1 },
        { text: 'Set 1', value: 0 },
      ]

      this.eventsBySet.forEach((set, index) => {
        this.setValues.push({ text: `Set ${index + 1}`, value: index })
      })
    },

    filterEvents (events) {
      let _events = events

      if (this.setSelection === -1 && this.typeSelection === -1) {
        return _events
      }

      if (this.setSelection !== -1) {
        if (this.reverseOrder) {
          _events = [_.nth(_events, -Math.abs(this.setSelection + 1))]
        } else {
          _events = [_.nth(_events, this.setSelection)]
        }
      }

      if (this.typeSelection !== -1) {
        let sets = []

        for (let set of _events) {
          sets.push(
            set.filter(event => event.code === this.typeSelection)
          )
        }

        _events = sets
      }

      return _events
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MatchLive/PlayByPlay/PlayByPlay.vue